const formikValidation = (data) => {

  let errors = {}

  if (!data.codgTipoCertidao) {
    errors.codgTipoCertidao = "Código do tipo é de preenchimento obrigatório"
  }

  if (!data.nomeTipoCertidao) {
    errors.nomeTipoCertidao = "Nome da certidão é de preenchimento obrigatório"
  }

  if (!data.siglTipoCertidao) {
    errors.siglTipoCertidao = "Sigla da certidão é de preenchimento obrigatório"
  }

  return errors;
}

export default formikValidation;
